"use strict";
/**
 * @module Services.RemoveTopic
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link RemoveTopic}
 */
var RemoveTopicSerialiserClass = /** @class */ (function (_super) {
    __extends(RemoveTopicSerialiserClass, _super);
    function RemoveTopicSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link RemoveTopic} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link RemoveTopic} to be written
     */
    RemoveTopicSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.selector.expression);
    };
    return RemoveTopicSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.RemoveTopicSerialiserClass = RemoveTopicSerialiserClass;
/**
 * The {@link RemoveTopicSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.RemoveTopicSerialiser = new RemoveTopicSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/remove-topic/remove-topic-serialiser.js
// module id = 1374
// module chunks = 1